import React, { useState } from 'react';

function parseBold(text) {
  const parts = (text || '').split(/\*\*(.+?)\*\*/g);
  return parts.map((part, i) => i % 2 === 1 ? <strong key={i}>{part}</strong> : part);
}

/**
 * Viewer de sección tipo "slider".
 * Props:
 *   section.sliderContent  {Array<{ title, body, image }>}
 *   onReady  {function}  - llamar cuando se llega a la última card
 */
export default function TrainingSliderSection({ section, onReady }) {
  const raw = section?.sliderContent?.cards ?? section?.sliderContent;
  const cards = (Array.isArray(raw) ? raw : raw ? Object.values(raw) : []).filter(Boolean);
  const [current, setCurrent] = useState(0);
  const readyFiredRef = React.useRef(false);

  if (cards.length === 0) return <div className="text-muted fst-italic">Sin cards configuradas.</div>;

  const card = cards[current] ?? null;
  const isLast = current === cards.length - 1;

  if (!card) return <div className="text-muted fst-italic">Tarjeta no disponible.</div>;

  const goNext = () => {
    if (isLast) {
      if (!readyFiredRef.current) { readyFiredRef.current = true; onReady && onReady(); }
      return;
    }
    setCurrent(c => c + 1);
  };

  const goPrev = () => setCurrent(c => Math.max(0, c - 1));

  return (
    <div className="tss-slider">
      {/* Indicadores */}
      <div className="d-flex justify-content-center mb-3" style={{ gap: 2 }}>
        {cards.map((_, i) => (
          <span
            key={i}
            style={{
              width: 8, height: 8, borderRadius: '50%',
              background: i === current ? '#3b82f6' : '#cbd5e1',
              display: 'inline-block',
              transition: 'background 0.2s',
            }}
          />
        ))}
      </div>

      {/* Card */}
      <div className=" p-4 text-center" style={{ minHeight: 200,background: '#F0F9FF',borderRadius: 8 }}>
        {card.image && (
          <img
            src={card.image}
            alt={card.title}
            style={{ maxHeight: 180, maxWidth: '100%', objectFit: 'contain', marginBottom: 16 }}
          />
        )}
        {card.title && <h6 className="fw-bold mb-2">{card.title}</h6>}
        {card.body  && <p className="text-muted mb-0" style={{ whiteSpace: 'pre-wrap' }}>{parseBold(card.body)}</p>}
      </div>

      {/* Navegación */}
      <div className="d-flex justify-content-between align-items-center mt-3">
        <button className='training-section-btn' onClick={goPrev} disabled={current === 0}>
          <i className="fas fa-arrow-left me-1" />Anterior
        </button>
        <span className="small text-muted">{current + 1} / {cards.length}</span>
        <button className={`training-section-btn ${isLast ? 'btn-success' : 'btn-primary'}`} onClick={goNext}>
          <i className="fas fa-check me-1" style={{ display: isLast ? 'inline' : 'none' }} />
          {isLast ? 'Finalizar' : 'Siguiente'}
          <i className="fas fa-arrow-right ms-1" style={{ display: isLast ? 'none' : 'inline' }} />
        </button>
      </div>
    </div>
  );
}
